import { beAsyncTasksApiGetTask } from 'Api/beAsyncTasksApiTS'

import type { TaskDetails } from 'Types/beAsyncTasks'

import type { AsyncTaskState } from 'Hooks/useAsyncTask/types'

export const getTaskDetails = async (
  idTask: number,
): Promise<Pick<TaskDetails, 'Status' | 'Metadata'>> => {
  const { Status, Metadata } = await beAsyncTasksApiGetTask(idTask)

  return { Status, Metadata }
}

export const errorUpdater = (p: AsyncTaskState): AsyncTaskState => ({
  ...p,
  status: 'error',
  loading: false,
})

export const pollingIterationUpdater = (p: AsyncTaskState): AsyncTaskState => ({
  ...p,
  pollingIteration: p.pollingIteration + 1,
})
